import {BasicPage} from '../components/basic-page.tsx';
import {FieldArrayDemo} from './forms/field-arrays.tsx';
import {Tabs} from '@mantine/core';
import {FC} from 'react';
import {FieldsDemo} from './forms/fields.tsx';

type TabConfig = {
  value: string;
  label: string;
  Component: FC;
};
const tabs = [
  {
    value: 'fieldArrays',
    label: 'Field Arrays',
    Component: FieldArrayDemo,
  },
  {
    value: 'fields',
    label: 'Fields',
    Component: FieldsDemo,
  },
] as const satisfies TabConfig[];

export const DemoPage = () => {
  return (
    <BasicPage title={'Demo Page'}>
      <Tabs defaultValue={tabs[0].value}>
        <Tabs.List mb={'sm'}>
          {tabs.map(({value, label}, index) => (
            <Tabs.Tab key={index} value={value} children={label} />
          ))}
        </Tabs.List>

        {tabs.map(({value, Component}, index) => (
          <Tabs.Panel key={index} value={value}>
            <Component />
          </Tabs.Panel>
        ))}
      </Tabs>
    </BasicPage>
  );
};